import React from "react";
import ReactDOM from 'react-dom/client';

import "config";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { getNonce } from "utils/getNonce";

(window as Window & { __webpack_nonce__?: string; __nonce__?: string }).__webpack_nonce__ = getNonce();
(window as Window & { __nonce__?: string }).__nonce__ = getNonce();

async function enableMocking() {
  if (process.env.REACT_APP_MOCK !== "true") {
    return;
  }

  const { worker } = await import("./mocks/browser");
  return worker.start({ onUnhandledRequest: "bypass" });
}

enableMocking().then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
